import React, {useState} from "react";
import "./SignerNameModal.scss"
import {FullScreenModal} from "../Modal/FullScreenModal";
import {Button} from "../ui-components/Button/Button";
import closeIcon from "../../assets/icons/times-solid.svg";
import {ToastService} from "../../service/ToastService";
import {SignerName} from "./SignerName/SignerName";

interface SignatureNameModalProps {
    onCloseModal: () => void;
    onSubmitModal: (signatureName: string) => void;
}

export const SignerNameModal: React.FunctionComponent<SignatureNameModalProps> = (props) => {
    const [signerName, setSignerName] = useState<string>('');

    const onSetSignerName = (value: string) => {
        setSignerName(value);
    }

    const closeModal = () => {
        props.onCloseModal();
    }

    const addSignerName = () => {
        if (!signerName) {
            ToastService.middleScreenWarningToast('Please type the signer name to continue.');
            return;
        }
        props.onSubmitModal(signerName);
        props.onCloseModal();
    }

    const renderSignatureContent = () => {
        return (
            <>
                <header>
                    <h1>Full Name of Signer</h1>
                    <img onClick={closeModal} className='image-icon desktop-2x clickable' src={closeIcon} alt="close"/>
                </header>

                <main className='signature-name-modal'>
                    {<div className="input-container signature-name-container">
                        <label>Full Name of Signer:</label>
                        <SignerName signerName={signerName} onSetSignerName={onSetSignerName}/>
                    </div>}
                </main>

                <footer className='signature-modal-footer'>
                    <Button className='white-button' onClick={closeModal}>Cancel</Button>
                    <Button className='green-button' onClick={addSignerName}>Submit</Button>
                </footer>
            </>
        )
    }

    return <FullScreenModal customClass={'signature-modal'}>
        {renderSignatureContent()}
    </FullScreenModal>

}
